import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "What is thinker and how does it work?",
      answer: "thinker is an AI-powered operations platform that helps e-commerce businesses automate tasks, streamline workflows, and grow faster with less chaos. It connects to your store and tools like Shopify, pulls your data, and activates AI agents to automate key operations like reporting, inventory alerts, and marketing suggestions."
    },
    {
      question: "Who is thinker for?",
      answer: "thinker is built for e-commerce founders, operators, and small teams who are scaling and wearing too many hats."
    },
    {
      question: "Do I need to know how to code?",
      answer: "No. thinker is designed for non-technical users. Just plug in your store, and let the AI handle the rest."
    },
    {
      question: "What platforms does thinker integrate with?",
      answer: "thinker currently integrates with Shopify, Meta Ads, Google Analytics, and more with additional integrations launching soon."
    },
    {
      question: "Can thinker make decisions for me?",
      answer: "Yes. thinker uses AI agents to give you actionable recommendations and even auto-execute tasks you approve."
    },
    {
      question: "How do I get started?",
      answer: "Sign up, connect your Shopify store, and choose what you want to automate. You'll get results in minutes."
    }
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-background">
      <div className="mx-auto max-w-4xl px-6">
        <h2 className="text-4xl md:text-5xl font-serif font-normal mb-12 text-foreground">
          FAQ
        </h2>
        
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border-b border-border"
            >
              <AccordionTrigger className="text-left text-base md:text-lg font-normal hover:no-underline py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
